<template>
  <div>
    <slot name="search-options" />
    <div>
      <slot name="table" />
      <div class="table_pagination mt-4">
        <el-pagination
          background
          class="col-auto"
          @current-change="changePage"
          layout="total, prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="totalCount"
        />
        <el-button
          type="primary"
          class="download-csv-button"
          @click="$emit('exportTable')"
        >
          <font-awesome-icon icon="fa-light fa-file-csv" class="mr-2" />
          {{ $t("sections.common.pagination.downloadCsvButton") }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PaginationWrapper',
  props: {
    export: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    totalCount: {
      type: Number || null,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    changePage(newPage) {
      this.$emit('onPageChange', newPage);
    },
  },
};
</script>
<style lang="scss" scoped>
.table_pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;

  ::v-deep .el-pagination__total {
    color: var(--primary-secondary);
  }

  ::v-deep li.number {
    background-color: transparent;
    color: var(--quaternary-white);
    font-weight: 400;

    &.active {
      background-color: var(--primary-secondary);
      color: white;
      font-weight: 600;
    }
  }

  ::v-deep .btn-next {
    background-color: transparent;
    color: var(--pagination-color);

    &:disabled {
      color: var(--pagination-color-disabled);
    }
  }

  ::v-deep .btn-prev {
    background-color: transparent;
    color: var(--pagination-color);

    &:disabled {
      color: var(--pagination-color-disabled);
    }
  }
}

.download-csv-button {
  position: absolute;
  right: 0;
  font-weight: 600;
  width: 200px;
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;

  i,
  svg {
    font-size: 18px;
  }
}
</style>
